import './App.css';
import Chat from './components/Chat';
import ChatMobile from './components/ChatMobile';
import ChatSanfer from './components/ChatSanfer';
import ChatSanferMobile from './components/ChatSanferMobile';
import Admin from './admin/admin';
import { UserProvider } from './userContext';
import { useEffect, useState } from 'react';

// Detect if the current URL is the dashboard-sanfer client
const isSanferClient = () => {
  const path = window.location.pathname.toLowerCase();
  const params = new URLSearchParams(window.location.search);
  return (
    path.includes('dashboard-sanfer') ||
    params.get('client')?.toLowerCase() === 'dashboard-sanfer'
  );
};

// Check if current path is the admin panel
const isAdminRoute = () =>
  window.location.pathname.toLowerCase().startsWith('/admin');

function App() {
  const [isMobile, setIsMobile] = useState(false);
  const [isSanfer] = useState(isSanferClient);
  const [isAdmin] = useState(isAdminRoute);

  useEffect(() => {
    // Device detection function
    const checkIfMobile = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const mobileRegex = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i;
      const isMobileDevice = mobileRegex.test(userAgent.toLowerCase());
      const isSmallScreen = window.innerWidth <= 768;

      setIsMobile(isMobileDevice || isSmallScreen);
    };

    // Check on mount
    checkIfMobile();

    // Listen for resize events
    window.addEventListener('resize', checkIfMobile);

    // Allow the app to be embedded in iframes
    if (window.self !== window.top) {
      console.log('App is running inside an iframe');
    }

    // Ensure client parameter is available for Chat component
    const urlParams = new URLSearchParams(window.location.search);
    const client = urlParams.get('client');
    if (client) {
      console.log('Client parameter detected:', client);
    }

    // Cleanup
    return () => {
      window.removeEventListener('resize', checkIfMobile);
    };
  }, []);

  // Admin route — rendered outside of UserProvider (no chat context needed)
  if (isAdmin) {
    return <Admin />;
  }

  return (
    <UserProvider>
      <div className="w-full h-screen bg-transparent">
        {isSanfer
          ? (isMobile ? <ChatSanferMobile /> : <ChatSanfer />)
          : (isMobile ? <ChatMobile /> : <Chat />)
        }
      </div>
    </UserProvider>
  );
}

export default App;
